import { render, staticRenderFns } from "./BlogComments.vue?vue&type=template&id=1d55e618"
import script from "./BlogComments.vue?vue&type=script&lang=js"
export * from "./BlogComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports